import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React from 'react';
import classnames from 'classnames';
import { func, bool, shape, number, oneOfType, arrayOf, string } from 'prop-types';

var ConfiguratorModalTrigger = function ConfiguratorModalTrigger(_ref) {
  var openModal = _ref.openModal,
    closeModal = _ref.closeModal,
    isModalOpen = _ref.isModalOpen,
    isComponentOpen = _ref.isComponentOpen,
    areSameProps = _ref.areSameProps,
    preserveOpen = _ref.preserveOpen,
    options = _ref.options,
    tabIndex = _ref.tabIndex,
    children = _ref.children,
    classes = _ref.classes,
    type = _ref.type,
    isCarouselOpen = _ref.isCarouselOpen,
    openFeatureModal = _ref.openFeatureModal,
    analyticsTriggerText = _ref.analyticsTriggerText,
    closeFeatureModal = _ref.closeFeatureModal,
    groupName = _ref.groupName,
    analyticsEventHandler = _ref.analyticsEventHandler;
  var handleModalClick = function handleModalClick() {
    if (isModalOpen) {
      closeModal();
    } else {
      if ((isComponentOpen && !areSameProps || !isComponentOpen) && !preserveOpen) {
        // close previous modal first
        closeModal();
      }
      openModal(options.props);
    }
  };
  var handleCarouselModalClick = function handleCarouselModalClick() {
    if (isCarouselOpen) {
      closeFeatureModal();
    }
    // groupName is passed only for the carousel modal
    // adding a check here to differentiate between add/remove or learn more button click(eg: fsd)
    if (groupName) {
      openFeatureModal({
        analyticsTriggerText: analyticsTriggerText,
        groupName: groupName
      });
    }
  };
  var handleClick = function handleClick(triggerer) {
    document.body.classList.add('using-mouse');
    if (triggerer !== undefined && triggerer === 'keyboard') {
      document.body.classList.remove('using-mouse');
    }
    if (analyticsEventHandler) {
      analyticsEventHandler();
    }
    switch (type) {
      case 'CAROUSEL':
        handleCarouselModalClick();
        break;
      default:
        handleModalClick();
    }
  };
  var handleKeyPress = function handleKeyPress(e) {
    if (e.charCode === 13 || e.charCode === 32) {
      handleClick('keyboard');
    }
  };
  var renderedChildren = function () {
    return typeof children === 'function' ? children : function returnChildren() {
      return children;
    };
  }()(isModalOpen);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('modal-trigger', _defineProperty({}, classes, classes)),
    role: "link",
    tabIndex: tabIndex,
    onClick: function onClick() {
      return handleClick();
    },
    onKeyPress: function onKeyPress(e) {
      return handleKeyPress(e);
    }
  }, renderedChildren);
};
ConfiguratorModalTrigger.propTypes = {
  analyticsEventHandler: func,
  openModal: func.isRequired,
  closeModal: func.isRequired,
  isModalOpen: bool.isRequired,
  isComponentOpen: bool,
  areSameProps: bool,
  preserveOpen: bool,
  options: shape({
    props: shape({})
  }),
  tabIndex: number,
  children: oneOfType([func, shape({}), arrayOf(shape({}))]).isRequired,
  classes: string,
  type: string.isRequired,
  isCarouselOpen: bool.isRequired,
  openFeatureModal: func.isRequired,
  analyticsTriggerText: string,
  closeFeatureModal: func.isRequired,
  groupName: string
};
ConfiguratorModalTrigger.defaultProps = {
  analyticsEventHandler: null,
  areSameProps: false,
  preserveOpen: false,
  options: {},
  tabIndex: 0,
  isComponentOpen: null,
  analyticsTriggerText: '',
  groupName: '',
  classes: ''
};

export { ConfiguratorModalTrigger as default };
